import React, { useState } from 'react';
import MasterPage from 'components/MasterPage';
import { Row, Container, Card, Tabs, Tab } from 'react-bootstrap';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';

export default function(){
  const [resale, setResale] = useState('');
  const getTamanho = (tamanho)=>{
    return window.innerWidth<=tamanho;
  }
  return (
    <Container fluid>
      <Row className="mt-2">
        <Link to="/master-agent/after-sales" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-1">
        <WidgetsOutlined className="icon-title col-auto p-0" />
        <h5 className="title-dashboard col-10 p-0">Pós Vendas - Novo Pedido</h5>
      </Row>
      <Row>
        <Card.Body className={"card-dashboard shadow bg-white rounded m-2 col-12"+(getTamanho(474)?'p-0':'p-5')}>
          <Tabs defaultActiveKey="goto" id="newQuote">
            <Tab eventKey="goto" title="GoTo">
              <iframe style={{ width: "100%", height: "70vh" }} src="https://embedded.scansource.com.br/configuradores/siptrunk/logmein/iframe" frameborder="0"></iframe>
            </Tab>
            {/* <Tab eventKey="net2phone" title="Net2Phone">
              <iframe style={{ width: "100%", height: "70vh" }} src="https://www.scansource.com.br/embed/configuradores/masteragent/net2phone" frameborder="0"></iframe>
            </Tab> */}
          </Tabs>
        </Card.Body>
      </Row>
    </Container>
  );
}
